import "./popup.css.ts.vanilla.mjs";
var _ = "p273__popup-3861_b432488__1ug8hi21", u = "p273__popup-3861_b432488__1ug8hi20", e = "p273__popup-3861_b432488__1ug8hi22";
export {
  _ as darkTheme,
  u as lightTheme,
  e as popupStyle
};
//# sourceMappingURL=popup.mjs.map
